import React from 'react';
import {Box, Stack} from '@mui/system';
import { Divider, Link, styled, Typography, useTheme } from '@mui/material';
import {paletteMains} from '@lib/utils';
import Grid from '@mui/material/Unstable_Grid2';
import logo from '@sass/images/footer/University_Wordmark_Reversed.png';
import { Facebook, Instagram, Pinterest, X, YouTube } from '@mui/icons-material';

const Footer = () => {
  const theme = useTheme();
  const palette = paletteMains(theme);

  const Logo = styled('a')({
    background: `url(${logo}) no-repeat`,
    backgroundSize: 'cover',
    width: '235px',
    height: '61px',
  });

  const FooterLink = styled(Link)({
    fontFamily: 'SourceSans',
    color: '#fff',
    textDecorationColor: '#fff',
    '&:hover': {
      color: palette.ilorange,
    }
  });

  const SocialLink = styled(Link)({
    color: '#fff',
    fontSize: '32px',
    '&:hover': {
      color: palette.ilorange,
    }
  });

  return (
    <>
      <Box id="footer" sx={{
        color: '#fff',
        marginTop: '100px',
        background: palette.ilblue,
        padding: '32px 0 24px',
      }}>
        <Grid container className="footer-layout" rowSpacing={2}>
          <Grid xsOffset={1} xs={10} className="footer-content">
            <Stack spacing={3} className="footer-primary-block">
              <Logo href="https://illinois.edu/" />
              <Grid container justifyContent="space-between" className="footer-primary-container">
                <Grid xs={'auto'} className="footer-primary-left">
                  <Typography variant="h3">
                    <FooterLink href="https://eat-move-save.extension.illinois.edu/">
                      Eat.Move.Save
                    </FooterLink>
                  </Typography>
                  <Typography variant="body1">
                    University of Illinois Extension
                    <br/>
                    Email: <FooterLink href="mailto:eatmovesave@illinois.edu">eatmovesave@illinois.edu</FooterLink>
                  </Typography>
                  <Stack direction="row" spacing={3} mt="8px" mb={{ xs: '24px', md: 0 }}>
                    <SocialLink href="https://www.instagram.com/eatmovesave/" aria-label="Eat Move Save Instagram">
                      <Instagram fontSize="inherit"/>
                    </SocialLink>
                    <SocialLink href="https://www.facebook.com/IllinoisNEP" aria-label="INEP Facebook">
                      <Facebook fontSize="inherit" />
                    </SocialLink>
                    <SocialLink href="https://twitter.com/IllinoisNEP" aria-label="INEP Twitter">
                      <X fontSize="inherit" />
                    </SocialLink>
                    <SocialLink href="https://www.youtube.com/@eatmovesave" aria-label="Eat Move Save YouTube">
                      <YouTube fontSize="inherit" />
                    </SocialLink>
                    <SocialLink href="https://www.pinterest.com/eatmovesave" aria-label="Eat Move Save Pinterest">
                      <Pinterest fontSize="inherit" />
                    </SocialLink>
                  </Stack>
                </Grid>
                <Grid xs={12} md={4} className="footer-primary-right" mb="16px">
                  <Typography>
                    This institution is an equal opportunity provider. This material was funded by USDA&apos;s Supplemental Nutrition Assistance Program - SNAP. &nbsp; <FooterLink href="https://eat-move-save.extension.illinois.edu/about/program-statement">Full Program Statement</FooterLink>
                  </Typography>
                </Grid>
              </Grid>
            </Stack>
          </Grid>
          <Grid xs={12} pt={0}>
            <Divider sx={{ borderColor: palette.ilalma, borderWidth: '3px' }}/>
          </Grid>
          <Grid xs={10} xsOffset={1} className="footer-secondary">
            <Stack direction={{ xs: 'column', md: 'row' }} spacing={{ xs: 2, md: 8 }}>
              <FooterLink href="https://www.vpaa.uillinois.edu/resources/web_privacy">Privacy Policy</FooterLink>
              <FooterLink href="https://illinois.edu/resources/website/copyright.html">© 2024 University of Illinois Board of Trustees</FooterLink>
            </Stack>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default Footer;
